import React from 'react'
import PT from 'prop-types'

import { formPropTypes } from 'common/auth/Shared/auth.helpers'
import { ButtonLonger } from 'common/auth/Shared/sharedStyled'
import FormError from 'components.v2/FormError'
import Input from 'components.v2/Input'
import withContainer from './GuestCheckoutFormContainer'

const GuestCheckoutForm = ({
  fields,
  isAuthenticating,
  errors,
  handleSubmit,
  handleChange,
  handleBlur,
  className,
  actionsReversed,
  email,
  serviceType,
  buttonAlign,
}) => (
  <form onSubmit={handleSubmit} noValidate className={className}>
    {!!errors.length &&
      errors.map((error, i) => <FormError key={i}>{error}</FormError>)}
    <Input
      onChange={handleChange}
      onBlur={handleBlur}
      value={fields.firstName.value}
      hasError={!!fields.firstName.error}
      className="block w-full"
      type="text"
      name="firstName"
      placeholder="First name"
    />
    <Input
      onChange={handleChange}
      onBlur={handleBlur}
      value={fields.lastName.value}
      hasError={!!fields.lastName.error}
      className="block w-full mt-10"
      type="text"
      name="lastName"
      placeholder="Last name"
    />
    <Input
      {...(email ? { autoFocus: true } : {})}
      onChange={handleChange}
      onBlur={handleBlur}
      value={fields.email.value || email}
      hasError={!!fields.email.error}
      className="block w-full mt-10"
      type="email"
      name="email"
      placeholder="Email"
    />
    <Input
      onChange={handleChange}
      onBlur={handleBlur}
      value={fields.mobile.value}
      hasError={!!fields.mobile.error}
      className="block w-full mt-10"
      type="tel"
      name="mobile"
      placeholder="Mobile"
    />
    <input
      value={serviceType}
      type="hidden"
      name="serviceType"
      className="hidden"
    />
    <div className="flex items-center justify-between mt-20">
      <ButtonLonger
        variant="primary"
        type="submit"
        disabled={isAuthenticating}
        actionsReversed={actionsReversed}
        buttonAlign={buttonAlign}
      >
        {isAuthenticating ? 'Processing…' : 'Continue as guest'}
      </ButtonLonger>
    </div>
  </form>
)

GuestCheckoutForm.propTypes = {
  ...formPropTypes,
  ...{
    serviceType: PT.string,
    buttonAlign: PT.string,
  },
}

export default withContainer(GuestCheckoutForm)
